import styled from 'styled-components';

import { BeneficiaryCardBadgeProps } from '../types';

export const BeneficiaryCardBadgeContainer = styled.div`
  margin-left: auto;
`;

export const BeneficiaryCardBadge = styled.div<BeneficiaryCardBadgeProps>`
  padding: 2px ${({ theme }) => theme.spacings.abs8}px;
  background: ${({ color, colorVariant = 3, theme }) =>
    theme.colors[color](colorVariant)};
  border-radius: 40px;
`;
